/* Rithu Karnika: product page behaviour */
(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents, format) {
    const fmt = format || '₹{{amount_no_decimals}}';
    const fix = (n, d, ts = ',', ds = '.') => {
      const [a, b] = (n / 100).toFixed(d).split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (b ? ds + b : '');
    };
    const key = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    let val;
    switch (key) {
      case 'amount_no_decimals': val = fix(cents, 0); break;
      case 'amount_with_comma_separator': val = fix(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fix(cents, 0, '.', ','); break;
      default: val = fix(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function initGallery(root) {
    const track = qs('[data-pdp-track]', root);
    if (!track) return () => {};
    const slides = qsa('[data-pdp-slide]', root);
    const dots = qsa('[data-pdp-dot]', root);
    const isSlider = () => getComputedStyle(track).display === 'flex';
    let raf;

    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, di) => d.classList.toggle('is-on', di === i));
        slides.forEach((s, si) => {
          const vid = qs('video', s);
          if (vid) si === i ? vid.play().catch(() => {}) : vid.pause();
        });
      });
    }, { passive: true });

    dots.forEach((d, i) => d.addEventListener('click', () => {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }));

    return (mediaId, smooth) => {
      const i = slides.findIndex(s => s.dataset.mediaId === String(mediaId));
      if (i < 0) return;
      if (isSlider()) {
        track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      } else if (smooth) {
        const r = slides[i].getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) slides[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
  }

  function initLightbox(root) {
    const dlg = qs('[data-pdp-lightbox]', root);
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const lt = qs('[data-lb-track]', dlg);
    const step = dir => lt.scrollBy({ left: dir * lt.clientWidth, behavior: 'smooth' });

    qsa('[data-pdp-zoom]', root).forEach(btn => btn.addEventListener('click', () => {
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      const i = Number(btn.dataset.pdpZoom) || 0;
      requestAnimationFrame(() => { lt.scrollLeft = i * lt.clientWidth; });
    }));
    dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    qs('[data-lb-close]', dlg).addEventListener('click', () => dlg.close());
    qs('[data-lb-prev]', dlg).addEventListener('click', () => step(-1));
    qs('[data-lb-next]', dlg).addEventListener('click', () => step(1));
    dlg.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  }

  function initDelivery(root) {
    qsa('[data-delivery]', root).forEach(el => {
      const out = qs('[data-delivery-date]', el);
      if (!out) return;
      const min = Number(el.dataset.min) || 3;
      const max = Math.max(min, Number(el.dataset.max) || min);
      const addBusinessDays = n => {
        const d = new Date();
        let c = 0;
        while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) c++; }
        return d;
      };
      const f = d => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      out.textContent = min === max ? f(addBusinessDays(min)) : `${f(addBusinessDays(min))} to ${f(addBusinessDays(max))}`;
    });
  }

  function initVariants(root, goToMedia) {
    const form = qs('[data-product-form]', root);
    const dataEl = qs('[data-variants]', root);
    const groups = qsa('[data-pdp-option]', root);
    if (!form || !dataEl || !groups.length) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const fmt = form.dataset.moneyFormat;
    const idInput = qs('[data-variant-id]', root);
    const priceEl = qs('[data-price]', root);
    const addBtn = qs('[data-add-button]', root);
    const buyNow = qs('[data-buy-now]', root);
    const barPrice = qs('[data-bar-price]');
    const barVariant = qs('[data-bar-variant]');
    const barAdd = qs('[data-bar-add]');

    const selected = () => groups.map(g => (qs('input:checked', g) || {}).value);
    const find = opts => variants.find(v => v.options.every((o, i) => o === opts[i]));

    const renderPrice = v => {
      if (!priceEl) return;
      if (v.compare_at_price > v.price) {
        const pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        priceEl.innerHTML = `<s>${formatMoney(v.compare_at_price, fmt)}</s><span class="on-sale">${formatMoney(v.price, fmt)}</span><span class="pdp-price__save">${pct}% off</span>`;
      } else {
        priceEl.innerHTML = formatMoney(v.price, fmt);
      }
    };

    const markAvailability = opts => {
      groups.forEach((g, gi) => {
        qsa('input', g).forEach(inp => {
          const test = opts.slice();
          test[gi] = inp.value;
          const m = find(test);
          inp.nextElementSibling.classList.toggle('is-out', !m || !m.available);
        });
      });
    };

    const update = fromUser => {
      const opts = selected();
      const v = find(opts);
      groups.forEach((g, i) => { const l = qs('[data-pdp-selected]', g); if (l) l.textContent = opts[i] || ''; });
      markAvailability(opts);

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.labelUnavailable; }
        if (buyNow) buyNow.hidden = true;
        return;
      }

      if (idInput) idInput.value = v.id;
      renderPrice(v);
      root.classList.toggle('is-sold-out', !v.available);
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldOut; }
      if (buyNow) buyNow.hidden = !v.available;
      if (barPrice) barPrice.innerHTML = formatMoney(v.price, fmt);
      if (barVariant) barVariant.textContent = v.title;
      if (barAdd) barAdd.disabled = !v.available;

      if (fromUser) {
        const u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u);
        if (v.media_id) goToMedia(v.media_id, true);
      }
      form.dispatchEvent(new CustomEvent('pdp:variant-change', { bubbles: true, detail: { variant: v } }));
    };

    groups.forEach(g => g.addEventListener('change', () => update(true)));
    update(false);

    const initial = find(selected());
    if (initial && initial.media_id && new URL(location.href).searchParams.has('variant')) goToMedia(initial.media_id, false);
  }

  function initRecs(scope = document) {
    qsa('[data-pdp-recs]', scope).forEach(async el => {
      if (el.dataset.loaded || !el.dataset.url) return;
      el.dataset.loaded = '1';
      try {
        const res = await fetch(el.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const inner = qs('[data-pdp-recs]', doc);
        if (inner && qs('.pdp-card', inner)) {
          el.innerHTML = inner.innerHTML;
          const wrap = el.closest('.pdp-recs');
          if (wrap) wrap.hidden = false;
        }
      } catch (e) { /* leave hidden */ }
    });
  }

  function init(scope = document) {
    qsa('[data-pdp]', scope).forEach(root => {
      if (root.dataset.pdpReady) return;
      root.dataset.pdpReady = '1';
      const goToMedia = initGallery(root);
      initLightbox(root);
      initDelivery(root);
      initVariants(root, goToMedia);
    });
    initRecs(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();